"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _link = _interopRequireDefault(require("@waglabs/link"));

var _ListItem = require("../ListItem");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledListItem = (0, _styledComponents["default"])(_ListItem.ListItem)(_templateObject(), function (_ref) {
  var hoverBackground = _ref.hoverBackground,
      hoverColor = _ref.hoverColor;
  return "\n    &:hover {\n      background: ".concat(hoverBackground, ";\n      color: ").concat(hoverColor, ";\n    }\n  ");
});

var NavigationItem = function NavigationItem(_ref2) {
  var url = _ref2.data.url,
      _ref2$linkProps = _ref2.linkProps,
      linkProps = _ref2$linkProps === void 0 ? null : _ref2$linkProps,
      rest = _objectWithoutProperties(_ref2, ["data", "linkProps"]);

  return url ? _react["default"].createElement(_link["default"], _extends({
    href: url,
    bg: "transparent",
    color: "medGray",
    hoverColor: "#727272",
    disabled: !url
  }, linkProps), _react["default"].createElement(StyledListItem, _extends({
    position: "relative"
  }, rest))) : _react["default"].createElement(StyledListItem, _extends({
    position: "relative",
    color: "medGray"
  }, rest));
};

exports.NavigationItem = NavigationItem;